/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/**
 * verwijderdeplanitems.ts
 * 10-06-2024 - Jelmer Jellema - Spin in het Web B.V. Apeldoorn NL
 * Component VerwijderdePlanItems
 * Selector: verwijderdeplanitems
 */
import {Component, Input} from '@angular/core';
import {Appscherm} from '../abstracts/appscherm';
import {Planitem} from '../../models/planitem';
import moment from 'moment';

@Component({
  selector: 'verwijderdeplanitems',
  templateUrl: './verwijderdeplanitems.html',
  styleUrls: ['verwijderdeplanitems.scss']
})
export class VerwijderdePlanitems extends Appscherm {
  magTerugzetten: boolean = false;

  constructor() {
    super('debug');
    this.magTerugzetten = this.api.can('planitem', 'full');
  }

  _verwijderd: Planitem[] = [];

  @Input() set verwijderd(v: Planitem[]) {
    this._verwijderd = v;
    for (let pi of this._verwijderd) {
      const vlog = pi.planitemlog.find(pl => pl.actie === 'verwijder');
      this.log.debug(`Verwijderd`,pi,vlog);
      if (vlog) {
        pi._tags.verwijderdatum = moment(vlog.createdAt).format('DD-MM-YYYY HH:mm:ss');
        pi._tags.verwijderaar = vlog?.gebruiker?.naam;
      }
    }
  }

  /**
   * Regel het terugzetten van het item
   * @param planitem
   */
  async terugzetten(planitem: Planitem) {
    try {
      await planitem.restore();
      this.api.toast("De dienst is teruggezet", "success");
    }
    catch {
      //wel een foutmelding geweest
    }
  }

}
